/**
 * Mobile Dialogs — замена нативных confirm() и alert()
 */

/** Тост-уведомление об ошибке (auto-dismiss 3s) */
export function mobileAlert(message: string): void {
    const existing = document.getElementById('mobileToastContainer');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'mobileToastContainer';
    toast.className = 'mobile-toast mobile-toast-error';
    toast.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>${escapeHtml(message)}</span>
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('visible'));
    setTimeout(() => {
        toast.classList.remove('visible');
        setTimeout(() => toast.remove(), 300);
    }, 3000);
}

/** Диалог подтверждения — возвращает Promise<boolean> */
export function mobileConfirm(message: string, danger = true): Promise<boolean> {
    return new Promise(resolve => {
        const overlay = document.createElement('div');
        overlay.className = 'mobile-confirm-overlay';
        overlay.innerHTML = `
            <div class="mobile-confirm-sheet">
                <div class="mobile-confirm-message">${escapeHtml(message)}</div>
                <div class="mobile-confirm-actions">
                    <button class="mobile-confirm-btn cancel">Отмена</button>
                    <button class="mobile-confirm-btn ${danger ? 'danger' : 'primary'}" id="confirmOkBtn">Подтвердить</button>
                </div>
            </div>
        `;

        document.body.appendChild(overlay);
        requestAnimationFrame(() => overlay.classList.add('visible'));

        const close = (result: boolean) => {
            overlay.classList.remove('visible');
            setTimeout(() => overlay.remove(), 250);
            resolve(result);
        };

        overlay.querySelector('.cancel')?.addEventListener('click', () => close(false));
        overlay.querySelector('#confirmOkBtn')?.addEventListener('click', () => close(true));
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(false); });
    });
}

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
